import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';

import {isMobile} from '../util';
import Burger from './Burger/Burger';
import MouseIcon from '../../assets/img/icons/icon-mouse.svg';
import TouchIcon from '../../assets/img/icons/icon-touch.png';
import PlusIcon from '../../assets/img/icons/icon-plus.svg';

import './Menu.css';

class Menu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            extended: false
        }

        this.props.history.listen((location, action) => {
            this.collapseMenu();
        })
    }

    toggleMenu = () => this.setState((prevState) => ({ extended: !prevState.extended }));
    collapseMenu = () => this.setState({ extended: false });

    renderSideLinks = () => {
        const { routes } = this.props;
        const navList = routes
            .map(({ path, exclude, crt }, key) => {
                if (!exclude) {
                    return (
                        <li key={key}>
                            <NavLink to={path}>
                                0{crt}
                            </NavLink>
                        </li>
                    )
                }
                return false;
            })
            .filter((el) => el !== undefined);

        return (
            <ul className="nav__list js__carousel-height">
                {navList}
            </ul>
        )
    }

    renderExtendedLinks = () => {
        const { routes } = this.props;
        const navList = routes
            .map(({ path, name, exclude, crt }, key) => {
                if (!exclude) {
                    return (
                        <li key={key}>
                            <NavLink
                                className="nav__link"
                                activeClassName="nav__link__active"
                                to={path}
                            >
                                <span className="link__title">
                                    <span className="title__crt">0{crt}</span>
                                    <span className="title__copy">{name}</span>
                                </span>
                                <span className="link__box">
                                    <img src={PlusIcon} alt="" />
                                </span>
                            </NavLink>
                        </li>
                    )
                }
                return false;
            })
            .filter((el) => el !== undefined);

        return (
            <ul className="nav__list">
                {navList}
            </ul>
        )
    }

    render() {

        return (
            <nav
                className="navigation main-navigation"
            >
                <div className="sidebar">
                    <Burger
                        active={this.state.extended}
                        clickHandler={this.toggleMenu}
                    />
                    <div className="nav nav__c-arctic">
                        {this.renderSideLinks()}
                    </div>
                    <div className="loader" style={{ height: '3px', width: '100%' }} ></div>
                    <div className="legend">
                        <img src={isMobile ? TouchIcon : MouseIcon} alt="Mouse Icon" />
                    </div>
                </div>
                <div className={`nav nav_extended ${this.state.extended && 'nav_extended_active'}`}>
                    {this.renderExtendedLinks()}
                </div>
            </nav>
        );
    }
}

Menu.propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
    })).isRequired
};

export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/components/navigation/Menu.jsx